// Styles
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Styles for the GroupSettingsForm component
 */ export const useGroupSettingsFormStyles = makeStyles({
    groupSettingsSection: {
        ...flexParent("column"),
        ...shorthands.gap(tokens.spacingVerticalM)
    },
    groupSettingsToggleButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        ...shorthands.padding(tokens.spacingVerticalS, "0"),
        minHeight: "32px"
    },
    groupSettingsToggleIcon: {
        fontSize: tokens.fontSizeBase300,
        marginRight: tokens.spacingHorizontalS
    },
    groupSettingsSectionTitle: {
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1
    },
    groupSettingsContent: {
        ...flexParent("column"),
        ...shorthands.gap(tokens.spacingVerticalL)
    },
    groupSettingsContentIndented: {
        paddingLeft: tokens.spacingHorizontalXL
    },
    groupSettingsLoadingContainer: {
        display: "flex",
        alignItems: "center",
        ...shorthands.gap(tokens.spacingHorizontalM),
        ...shorthands.padding(tokens.spacingVerticalM, "0")
    },
    groupSettingsLoadingText: {
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase300
    },
    groupSettingsFieldsContainer: {
        ...flexParent("column"),
        ...shorthands.gap(tokens.spacingVerticalL)
    },
    fieldLabel: {
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase300
    },
    groupInputStyle: {
        width: "100%",
        borderRadius: tokens.borderRadiusXLarge,
        border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
        ":focus-within::after": {
            content: '""',
            position: "absolute",
            inset: "-1px",
            borderRadius: "unset",
            borderBottomLeftRadius: tokens.borderRadiusXLarge,
            borderBottomRightRadius: tokens.borderRadiusXLarge,
            borderBottom: `${tokens.strokeWidthThick} solid ${tokens.colorCompoundBrandStroke}`,
            clipPath: "inset(0px)",
            height: "auto",
            pointerEvents: "none"
        }
    },
    privacyField: {
        ...flexParent("column"),
        ...shorthands.gap(tokens.spacingVerticalS)
    },
    privacyDisabledNote: {
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase200,
        fontStyle: "italic",
        marginTop: tokens.spacingVerticalS
    },
    sensitivityLabelSection: {
        ...flexParent("column")
    }
});
